module.exports = {
	"articleTitle1": "Giancarlo Buonomo: Sourdough starter the secret to Jolly Pumpkin's ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Jolly Pumpkin Café & Brewery",
	"articleLink1": "https://www.michigandaily.com/section/arts/giancarlo-buonomo-sourdough-starter",
	"articleLink2": "https://www.michigandaily.com/content/lila-kalick-jolly-pumpkin",
	"articleSnippet1": "Sep 17, 2015 ... Jolly Pumpkin pizza is baked on a sourdough crust, made with a starter that could \nbe 130 years old, has traveled thousands of miles, and ...",
	"articleSnippet2": "Sep 22, 2010 ... Look out! The Jolly Pumpkin, brewery-turned-sensational-snacking-spot, is \nserving up a smackdown and shaking up Main Street's somewhat ...",
	"foodRecommendations": [],
	"articleTitle2": "Lila Kalick: A jolly time at the Pumpkin",
	"address": "311 S Main St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/150928/vel.ART_.brewery.519.JPG?itok=PU8BHvCH",
			"author": "Virginia Lozano",
			"caption": "Bartender and server Maureen Terrill pours a glass of beer at the Jolly Pumpkin Cafe and Brewery"
		}
	],
	"position": {
		"lat": 42.27915,
		"lng": -83.748473
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/jollypumpkin.json
// module id = 900
// module chunks = 0